import { FORMULATION_UNKNOWN_ISSUE_CODE } from '../../constants';

import { HorizontalContainer, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import PanelSection from 'components/PanelSection';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const MixOrderGroup: FunctionComponent<Props> = ({
    className = '',
    header,
    issues,
    items,
    testId = TEST_ID,
    unknownFormulationText
}) => (
    <PanelSection className={`${styles.mixOrderGroup} ${className}`} testId={testId} text={header}>
        <VerticalContainer className={styles.chemicalList}>
            {items.map(item => {
                const hasUnknownFormulation = issues.some(
                    issue =>
                        issue.chemicalId === item.chemical.chemicalId &&
                        issue.code === FORMULATION_UNKNOWN_ISSUE_CODE
                );
                const unknownFormulationClass = hasUnknownFormulation
                    ? styles.unknownFormulation
                    : '';

                return (
                    <HorizontalContainer
                        className={styles.chemicalRow}
                        key={item.chemical.chemicalId}>
                        <Wrapper>{item.chemical.labelName}</Wrapper>

                        <Wrapper
                            className={`${styles.formulationBadge} ${unknownFormulationClass}`}>
                            {item.chemical.formulationCode ?? unknownFormulationText}
                        </Wrapper>
                    </HorizontalContainer>
                );
            })}
        </VerticalContainer>
    </PanelSection>
);

export default MixOrderGroup;
